import { animate, useInView } from 'framer-motion';
import React, { useEffect, useRef, useState } from 'react';
import { CounterProps } from './Counter.types';
import { StyledCaption, StyledNumber, StyledStack } from './styles';

export const Counter = ({
  to,
  caption,
  infinite,
}: CounterProps): React.ReactElement => {
  const [animationCompleted, setAnimationCompleted] = useState(false);
  const inViewRef = useRef(null);
  const inView = useInView(inViewRef, { once: true });
  const numberRef = useRef<HTMLElement>(null);

  useEffect(() => {
    const numberRefCurrent = numberRef?.current;

    if (numberRefCurrent) {
      setTimeout(() => {
        numberRefCurrent.innerHTML = '0';
      }, 100);
    }

    if (inView) {
      if (infinite) {
        const controls = animate(0, to, {
          duration: 2,
          ease: 'easeOut',
          delay: 0.1,
          onUpdate: (value) => {
            if (numberRef.current) {
              numberRef.current.innerHTML = value.toFixed(0);
            }
          },
          onPlay: () => {
            setAnimationCompleted(false);
          },
          onComplete: () => {
            setAnimationCompleted(true);
            if (numberRef.current) {
              numberRef.current.innerHTML = `
              <svg viewBox="0 0 120 60"
                   style="height:1em; vertical-align:middle"
                   aria-hidden="true">
                <defs>
                  <linearGradient id="neutralInfinity"
                    gradientUnits="userSpaceOnUse"
                    x1="0" y1="60"
                    x2="120" y2="0">
                    <stop offset="0%" stop-color="#7E8B99"/>
                    <stop offset="100%" stop-color="#FFFFFF"/>
                  </linearGradient>
                </defs>
              
                <path
                  d="
                    M20 30
                    C20 10, 50 10, 60 30
                    C70 50, 100 50, 100 30
                    C100 10, 70 10, 60 30
                    C50 50, 20 50, 20 30
                  "
                  fill="none"
                  stroke="url(#neutralInfinity)"
                  stroke-width="10"
                  stroke-linecap="round"
                  stroke-linejoin="round"/>
              </svg>
              `;
            }
          },
        });

        return () => {
          controls.stop();
        };
      } else {
        const controls = animate(0, to, {
          duration: 2,
          ease: 'easeOut',
          delay: 0.1,
          onUpdate: (value) => {
            if (numberRef.current)
              numberRef.current.innerHTML = value.toFixed(0);
          },
        });
        return () => controls.stop();
      }
    }
  }, [to, inView, infinite]);

  return (
    <StyledStack ref={inViewRef}>
      <StyledNumber
        sx={{
          ...(animationCompleted && infinite
            ? {
                transition: 'font-size 0.5s ease-in-out',
                marginTop: '-10px !important',
              }
            : {}),
        }}
        variant={'display_md'}
        ref={numberRef}>
        {to}
      </StyledNumber>
      {caption && <StyledCaption variant="strong_300">{caption}</StyledCaption>}
    </StyledStack>
  );
};
